import { Box, Typography } from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';

export function HeroVideoSearchEmptyState() {
  return (
    <Box
      sx={{
        mt: 2,
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        bgcolor: 'grey.50',
        borderRadius: 2,
        border: '2px dashed',
        borderColor: 'grey.300',
      }}
    >
      <VideocamIcon sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />
      <Typography variant="body2" color="text.secondary">
        Sök efter en video att använda som hero
      </Typography>
    </Box>
  );
}
